export default __webpack_public_path__ + "2b1cd6f6b23b8e37aa6eb5667a63e28c.png";